import { IncomeRoutes } from '../../routes/income';
import { PersonalDetailsRoutes } from '../../routes/personal_details';
import { SpouseIncomeRoutes } from '../../routes/spouseIncome';
import { TaxesDeductionsRoutes } from '../../routes/taxesDeductions';
import { BaseQuestionnaireRoute } from '../../routes/slice';
import { NonUsFinancialAccountsRoutes } from '../../routes/nonUsFinancialAccounts';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
} from '../components/Accordion';
import SecondLevelSubTabs from './SecondLevelSubTabs';
import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';

interface IFirstLevelSubTabs {
  mainTabPath: string;
  subRoutes: BaseQuestionnaireRoute;
}

const FirstLevelSubTabs = ({ mainTabPath, subRoutes }: IFirstLevelSubTabs) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState<string>('');

  useEffect(() => {
    const pathParts = location?.pathname?.split('/').slice(4);
    pathParts && setOpen(pathParts[1]);
  }, [location]);

  const firstLevelSubTabs = Object.values(subRoutes);

  return (
    <div className="flex h-full flex-col gap-4">
      {firstLevelSubTabs.map((subRoute) => {
        const {
          path: firstLevelSubTabPath,
          title,
          isValid,
          toggle,
          ...rest
        } = subRoute;

        const subTabs: BaseQuestionnaireRoute = rest;
        const secondLevelSubTabs = Object.values(subTabs);
        const doesHaveSeconndLevelSubTabs = secondLevelSubTabs.length > 0;

        return (
          <Accordion
            key={title}
            open={open === firstLevelSubTabPath}
            showIcon={firstLevelSubTabs.length > 1}
            onClick={() =>
              navigate(
                `${mainTabPath}/${firstLevelSubTabPath}${
                  doesHaveSeconndLevelSubTabs
                    ? `/${secondLevelSubTabs[0].path}`
                    : ''
                }`,
              )
            }
            className={`border rounded-md px-4 ${
              open === firstLevelSubTabPath ? 'flex-1' : 'flex-none'
            }`}
          >
            <AccordionHeader className="font-medium text-base">
              {title}
            </AccordionHeader>
            <AccordionBody>
              {doesHaveSeconndLevelSubTabs ? (
                <SecondLevelSubTabs
                  mainTabPath={mainTabPath}
                  firstLevelSubTabPath={firstLevelSubTabPath}
                  subTabs={subTabs}
                />
              ) : open === firstLevelSubTabPath ? (
                <Outlet />
              ) : (
                <></>
              )}
            </AccordionBody>
          </Accordion>
        );
      })}
    </div>
  );
};

export default FirstLevelSubTabs;
